"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Bx/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value");

function render(input, out, __component, component, state) {
  var data = input;

  out.e("i", {
      "class": marko_classValue(marko_classValue([
        "bx",
        ((((input.bxs || input.bxl ? input.bxs ? "bxs" : "bxl" : "bx") + "-") + input.type) + " ") + input.class
      ])),
      style: marko_styleValue(input.style)
    }, "0", component, 0, 1, {
      onclick: __component.d("click", () => component.emit('click'), false)
    });
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
